















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Order,
  OrderPayment,
  PaymentMethods
} from '@/store/modules/order/order.types';
import { SortOrder } from '@/store/types/general.types';

import BaseTable from '@/components/BaseTable.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import BpointResponseCodes from '@/assets/bpoint-response-codes.json';

@Component({
  components: {
    BaseTable,
    SortableTableHeader,
    BasePagination,
    BaseLoading
  }
})
export default class OrderList extends Vue {
  @Prop({ type: String, required: true }) public itemType!: string;

  @Prop(Array) public items!: Order[];
  @Prop(Boolean) public isLoading!: boolean;
  @Prop(Number) public totalCount!: number;
  @Prop(Number) public page!: number;
  @Prop(Number) public perPage!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: SortOrder;

  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;

  public sortHeaders = [
    {
      placeholder: 'Item',
      field: 'name',
      sortable: true,
      width: '40%'
    },
    {
      placeholder: 'Date',
      field: 'createdAt',
      sortable: false,
      width: '20%'
    },
    {
      placeholder: 'Amount',
      field: 'amount',
      sortable: false,
      width: '15%'
    },
    {
      placeholder: 'Status',
      field: 'status',
      sortable: false,
      width: '15%'
    }
  ];

  get currentPage(): number {
    return this.page;
  }
  set currentPage(value: number) {
    this.$emit('update:page', value);
  }

  get currentPerPage(): number {
    return this.perPage;
  }
  set currentPerPage(value: number) {
    this.$emit('update:perPage', value);
  }

  public getMostRecentPayment(item: Order): OrderPayment | null {
    if (!item.payments || item.payments.length === 0) {
      return null;
    }
    const sortedPayments = [...item.payments].sort((a, b) => {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
    return sortedPayments[0];
  }

  public getDisplayAmount(item: Order): string {
    const payment = this.getMostRecentPayment(item);
    if (!payment || typeof payment.amount !== 'number') {
      return 'N/A';
    }
    const formattedNumber = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: payment.currency || 'AUD',
      currencyDisplay: 'narrowSymbol'
    }).format(payment.amount / 100);

    return `${formattedNumber} ${payment.currency}`;
  }

  public getDisplayStatus(item: Order): string {
    const payment = this.getMostRecentPayment(item);

    return (payment && payment.status) || 'PENDING';
  }

  public getDisplayStatusText(item: Order): string {
    const status = this.getDisplayStatus(item);

    if (status === 'SUCCESS') {
      return 'PAID';
    }

    if (status === 'PENDING') {
      const paymentType = this.getPaymentType(item);
      return `${status} ${paymentType}`;
    }
    return status;
  }

  public getPaymentType(item: Order): string {
    const payment = this.getMostRecentPayment(item);
    return payment && payment.paymentType === PaymentMethods.CREDIT_CARD
      ? 'CREDIT CARD PAYMENT'
      : 'BANK TRANSFER';
  }

  public getFailureReason(item: Order): string {
    const payment: OrderPayment | null = this.getMostRecentPayment(item);
    if (payment && payment.txnResponsePayload) {
      let responseCode = `${payment.txnResponsePayload.responseCode}`;

      if (payment.txnResponsePayload.bankResponseCode) {
        responseCode += `:${payment.txnResponsePayload.bankResponseCode}`;
      }
      const responseCodeText = BpointResponseCodes.find(
        (code) => code.responseCode === responseCode
      );

      if (responseCodeText) {
        return responseCodeText.responseText;
      }
    }

    return 'Payment failed due to an unknown error.';
  }

  public formatDate(dateString: Date): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }

  public onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder: this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: 'DESC'
    });
  }

  public getSortOrderOfColumn(field: string): SortOrder {
    if (this.sortColumn === field) {
      return this.sortOrder;
    }
    return SortOrder.ASC;
  }

  public handleRetry(item: Order): void {
    const payment = this.getMostRecentPayment(item);
    if (payment) {
      this.$emit('retry', { paymentId: payment.id });
    }
  }

  public navigateToOrderPage(orderId: number) {
    return this.$router.push({ name: 'Order', params: { id: orderId + '' } });
  }
}
